import { useState, useEffect } from 'react'

import sinfoto from '../../../src/img/sinfoto.jpg'
import * as publicacionesService from '../servicios/publicacionesService'

export const useImagenPublicacion = (idPublicacion) => {
  const [imagenUrl, setImagenUrl] = useState(sinfoto)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let objectUrl
    let cancelado = false

    const obtenerImagen = async () => {
      try {
        const { data } = await publicacionesService.BuscarImagen(idPublicacion)

        if (cancelado) {
          return
        }

        if (data.size !== 0) {
          objectUrl = URL.createObjectURL(data)
          setImagenUrl(objectUrl)
        } else {
          setImagenUrl(sinfoto)
        }
      } catch {
        setImagenUrl(sinfoto)
      } finally {
        if (!cancelado) {
          setLoading(false)
        }
      }
    }

    idPublicacion && obtenerImagen()

    return () => {
      cancelado = true
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [idPublicacion])

  return { imagenUrl, loading }
}
